import { z } from 'zod';

export class AccessCode {
  constructor(
    public id: string,
    public code: string,
    public userId: string,
    public classroomId: string
  ) {}

  public static zodSchema = z.object({
    id: z.string(),
    code: z.string(),
    userId: z.string(),
    classroomId: z.string(),
  });

  public static fromJson(json: unknown): AccessCode {
    const validJson = this.check(json);
    const accessCode = new AccessCode(validJson.id, validJson.code, validJson.userId, validJson.classroomId);
    return accessCode;
  }

  public static fromJsonArray(jsonArray: unknown): AccessCode[] {
    const validJsonArray = this.checkArray(jsonArray);
    return validJsonArray.map((json) => this.fromJson(json));
  }

  public static check(json: unknown): z.infer<typeof this.zodSchema> {
    return this.zodSchema.parse(json);
  }

  public static checkArray(jsonArray: unknown): z.infer<typeof this.zodSchema>[] {
    return z.array(this.zodSchema).parse(jsonArray);
  }
}
